// extracted by mini-css-extract-plugin
module.exports = {"container":"Cover_container__1NJGx"};